<template>
<div>
    <div id="chart" v-if="data && data[0] && data[0].label">
        <div class="bar-wrapper" v-for="(year, index) in data" :key="index" :style="{maxWidth: getMaxWidth(year, data)}">
            <!-- Year Label -->
            <div class="bar-label-year">
                {{ year.label }}
            </div>

            <!-- Stacked Bars -->
            <div class="bar-outer">
                <div class="bar-inner" :style="{ width: '100%' }">
                    <div class="bar" v-for="(stack, sIndex) in year.stacks" :key="sIndex" :style="{
                        width: (stack.value / getTotal(year.stacks)) * 100 + '%',
                        backgroundColor: getColor(sIndex)
                    }">
                        <span class="bar-label">{{ formatPercent(stack, year.stacks) }}</span>
                        <span class="bar-label-second">{{ formatShort(stack.value) }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <p v-else>Nicht genug Daten, um ein Chart zu erstellen.</p>
    <div class="legend-wrapper">
        <div class="legent" v-for="(group, index) in uniqueGroups" :key="index">
            <span :style="{ backgroundColor: getColor(index) }"></span>
            {{ group }}
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'HorizontalStackedBarChart',
    props: {
        data: {
            type: Array,
            default: () => []
        },
        uniqueGroups: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            // data: [
            //     {
            //         label: '2023',
            //         stacks: [
            //             {
            //                 label: "120000",
            //                 value: 120000
            //             },
            //             {
            //                 label: "240000",
            //                 value: 24
            //             },
            //             {
            //                 label: "360000",
            //                 value: 36
            //             },
            //         ]
            //     },
            //     {
            //         label: '2024',
            //         stacks: [
            //             {
            //                 label: "120000",
            //                 value: 12
            //             },
            //             {
            //                 label: "240000",
            //                 value: 24
            //             },
            //             {
            //                 label: "360000",
            //                 value: 36
            //             },
            //         ]
            //     },
            //     {
            //         label: '2025',
            //         stacks: [
            //             {
            //                 label: "120000",
            //                 value: 12
            //             },
            //             {
            //                 label: "240000",
            //                 value: 24
            //             },
            //             {
            //                 label: "360000",
            //                 value: 36
            //             },
            //         ]
            //     },
            // ],
            colors: [
                '#4CAF50', // Green
                '#2196F3', // Blue
                '#FFC107', // Amber
                '#FF5722', // Deep Orange
                '#9C27B0', // Purple
            ],
        }
    },
    methods: {
        getTotal(stacks) {
            if (!stacks) return 0;
            return stacks.reduce((total, stack) => total + stack.value, 0);
        },
        getColor(index) {
            return this.colors[index % this.colors.length];
        },
        formatShort(num) {
            num = Math.round(num/100);
            if (num >= 1e9) {
                return (num / 1e9).toFixed(1).replace(/\.0$/, '') + 'b';
            }
            if (num >= 1e6) {
                return (num / 1e6).toFixed(1).replace(/\.0$/, '') + 'm';
            }
            if (num >= 1e3) {
                return (num / 1e3).toFixed(1).replace(/\.0$/, '') + 'k';
            }
            return num.toString();
        },
        formatEuro(amount) {
            return new Intl.NumberFormat('de-DE', {
                style: 'currency',
                currency: 'EUR',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(amount/100);
        },
        getMaxWidth(item, total) {
            const _total = this.getTotal(item.stacks);
            const _max = Math.max(...total.map(t => (this.getTotal(t.stacks))));
            const width = (_total / _max) * 100;
            return width < 5 ? '7%' : width + '%';
        },
        formatPercent(stack, stacks) {
            return Math.round((stack.value / this.getTotal(stacks)) * 100) + '%';
        }
    }
};
</script>

<style lang="scss" scoped>
#chart {
    width: 100%;
    max-width: 800px;
    min-width: 800px;
    margin: 0 auto;

    .bar-wrapper {
        display: flex;
        align-items: center;

        .bar-label-year {
            width: 40px;
            font-weight: 500;
            margin-right: 4px;
            font-size: 14px;
        }

        .bar-outer {
            flex: 1;
            background-color: #e0e0e0;
            border-radius: 4px;
            overflow: hidden;
            position: relative;

            .bar-inner {
                display: flex;
                height: 30px;

                .bar {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    position: relative;
                    transition: flex-grow 0.3s ease;
                    border: 1px solid white;

                    .bar-label,
                    .bar-label-second {
                        position: absolute;
                        top: 0;
                        left: 0;
                        right: 0;
                        bottom: 0;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        color: #fff;
                        font-size: 12px;
                        white-space: nowrap;
                        text-align: center;
                        cursor: default;
                        font-weight: 500;
                    }

                    .bar-label {
                        opacity: 0;
                    }

                    &:hover {
                        .bar-label {
                            opacity: 1;
                        }

                        .bar-label-second {
                            opacity: 0;
                        }
                    }
                }
            }
        }
    }
}

.legend-wrapper {
    display: flex;
    justify-content: center;
    margin-top: 16px;

    .legent {
        display: flex;
        align-items: center;
        margin-right: 16px;

        span {
            width: 16px;
            height: 16px;
            border-radius: 50%;
            margin-right: 8px;
        }
    }
}
</style>